import * as React from 'react'
import CategoryRecommendLectureModule from './CategoryRecommendLectureModule/CategoryRecommendLectureModule'
import * as Styles from './CategoryRecommendPage.style'
import {HttpServer} from '@/services/server'
import {getJsonFromUrl} from '../../../../utils/tools'
import CategoryMenuItem from '../CategoryMenuItem/CategoryMenuItem'
import CategoryType from '../../type/CategoryType'
import globalBus from '@/services/Bus'

declare const Session: any

interface CategoryRecommendPageState {
    modules: any,
    init: boolean,
    category?: CategoryType.Category | undefined | any
}

interface CategoryRecommendPageProps {
    changeCategoryId: (selectCid: number, type?: string) => void
}

export default class CategoryRecommendPage extends React.Component <CategoryRecommendPageProps, CategoryRecommendPageState> {
    public constructor(props) {
        super(props)
        globalBus.bindComponent(this, {
            changeRecommendCategoryId: (info) => {
               this.loadRecommendData(info)
            }
           }
        )
        this.state = {
            modules: [],
            init: false,
            category: {}
        }
    }

    public componentDidMount() {
        document.title = '精选'
        this.loadRecommendData(getJsonFromUrl().id)
    }

    public loadRecommendData(id: string) {
        const key = 'HOMEPAGE/Category/RecommendData'
        const expireKey = 'HOMEPAGE/Category/RecommendData/expireTime'
        const CategoryId = 'HOMEPAGE/Category/RecommendData/Id'
        // 如果小于5分钟不去取接口数据，减少接口渲染空白期
        const getStorageReady = window.localStorage.getItem(key) && window.localStorage.getItem(expireKey) && window.localStorage.getItem(CategoryId)
        if (window.localStorage.getItem(expireKey) && getStorageReady && new Date().getTime() - parseInt(window.localStorage.getItem(expireKey), 10) <= 300000 && id === (window.localStorage.getItem(CategoryId))) {
            const getStorageData = JSON.parse(window.localStorage.getItem(key))
            this.setState({
                ...getStorageData,
                init: true
            }, () => {
                if (getJsonFromUrl().id !== getStorageData.category.sub_categories[0].parent_id) {
                    globalBus.emit({categoryActiveId: getStorageData.category.sub_categories[0].parent_id})
                }
                globalBus.emit({categoryMenuData: getStorageData.category})
            })
        } else {
            HttpServer.getCategoryRecommendAllData(id).then((res) => {
                if (res.data.code === 0) {
                    if (Session.weixinApi) {
                        Session.weixinApi.initJSSDK()
                        const info = res.data.data.share_info

                        const shareData = {
                            title: info.title,
                            link: window.location.origin + window.location.pathname + window.location.search,
                            desc: info.content,
                            imgUrl: info.share_url
                        }

                        const timeShareData = {
                            ...shareData,
                            link: `https://share.lizhiweike.com${window.location.pathname}${window.location.search}`
                        }

                        Session.weixinApi.wxShare([shareData, timeShareData])
                    }
                    window.localStorage.setItem(key, JSON.stringify(res.data.data))
                    window.localStorage.setItem(expireKey, (new Date().getTime().toString()))
                    window.localStorage.setItem(CategoryId, id.toString())
                    if (getJsonFromUrl().id !== res.data.data.category.sub_categories[0].parent_id) {
                        globalBus.emit({categoryMenuData: res.data.data.category})
                    }
                    globalBus.emit({categoryActiveId: res.data.data.category.sub_categories[0].parent_id})
                    this.setState({
                        modules: res.data.data.modules,
                        category: res.data.data.category,
                        init: true
                    })
                }
            })
        }
    }

    public changeCategory = (val: number, type?: string) => {
        if (type === 'recommend') {
            this.props.changeCategoryId(val, 'recommend')
        } else {
            this.props.changeCategoryId(val)
        }
    }

    public renderModules = (content: any) => {
        switch (content.module_style) {
            case '7':
                return <CategoryRecommendLectureModule content={content} key={content.id}/>
            case '8':
                return content.contents.map((v: any) => {
                    return (
                        <div className="coverPicModel" key={v.content_id}>
                            <a href={v.cover_urls[0].advertisement_url_1}><img src={v.cover_urls[0].cover_url} alt=""/></a>
                        </div>
                    )
                })
            default:
                return null
        }
    }

    public render() {
        return (
           <div>
               {this.state.init ?
                <div>
                    <div className={Styles.CategoryRecommendPage}>
                        {this.state.modules !== [] && this.state.modules.map((v: any) => (
                            this.renderModules(v)
                        ))}
                    </div>
                </div> : null}
           </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Category/components/CategoryRecommendPage/CategoryRecommendPage.tsx